import { createStore, createEvent } from "effector"
import { IReservationSidebarProps } from "components/ReservationSidebar/ReservationSidebar"

const show = createEvent<IReservationSidebarProps>()
const hide = createEvent<IReservationSidebarProps>()
const clear = createEvent()

const list = createStore<IReservationSidebarProps[]>([])

list.on(show,
    (state: IReservationSidebarProps[], props: IReservationSidebarProps) => {
        return [...state, props]
    }
)

list.on(hide,
    (state: IReservationSidebarProps[], props: IReservationSidebarProps) => {
        return state.filter(p => p !== props)
    }
)

list.on(clear,
    () => []
)

export default {
    show,
    hide,
    clear,
    list,
}
